import React from "react";
import Loadable from "../../react-loadable";
const TransferOperation = Loadable({
  loader: () => import("./operation"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default TransferOperation;



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer/OperationAsync.jsx